<template>
  <div>
    <v-alert type="info" text>
      Die zukünftigen Schüler:innen erhalten den Link zur Welcome-Seite im
      Willkommensbrief. Hier erkennt man den Status des Checkins.
    </v-alert>
    <v-card>
      <v-toolbar flat>
        <v-switch
          inset
          v-model="filter.showTodo"
          label="Nur nicht-abgeschlossene Checkins anzeigen"
          hideDetails
        />
        <v-spacer></v-spacer>
        <ReportButton
          outlined
          text
          resource="report/checkin"
          color="danger"
          :parameters="{
            changedOnly: false,
            futureOnly: false,
          }"
          >Versand (PDF)</ReportButton
        >
      </v-toolbar>

      <v-data-table
        :items="itemsSearched"
        :headers="headers"
        :loading="loading"
      >
        <template v-slot:item.person="{ item }">
          <PersonItem small :value="item.person" />
        </template>
        <template v-slot:item.checkedIn="{ item }">
          <v-simple-checkbox
            v-model="item.checkedIn"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.hasConfirmed="{ item }">
          <v-simple-checkbox
            v-model="item.hasConfirmed"
            disabled
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.open="{ item }">
          <v-simple-checkbox v-model="item.open" disabled></v-simple-checkbox>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { comparePeople, searchPerson } from "common/utils/people.js";

import PersonItem from "common/components/PersonItem.vue";
import ReportButton from "@/components/ReportButton";
import { filter } from "lodash";

export default defineComponent({
  name: "OnBoardingCheckinGYM0",
  props: ["search"],
  components: { PersonItem, ReportButton },
  data() {
    return {
      loading: false,
      items: [],
      filter: {
        showTodo: false,
      },
      headers: [
        {
          text: "Schüler:in",
          value: "person",
          sort: comparePeople,
        },
        {
          text: "Status Personalien",
          value: "checkedIn",
          align: "center",
        },
        {
          text: "Status Fächerwahl",
          value: "hasConfirmed",
          align: "center",
        },
        {
          text: "Anmeldung offen",
          value: "open",
          align: "center",
        },
      ],
    };
  },

  methods: {
    async fetchData() {
      this.loading = true;
      this.items = await this.apiList({
        resource: "onboarding/checkin",
        query: "gym0",
      });
      this.loading = false;
    },
  },
  computed: {
    itemsSearched() {
      if (!this.search) {
        return this.itemsFiltered;
      }
      return this.itemsFiltered?.filter((el) =>
        searchPerson(el.person, this.search)
      );
    },
    itemsFiltered() {
      if (this.filter.showTodo) {
        return filter(
          this.items,
          (item) => !item.hasConfirmed || !item.checkedIn
        );
      }
      return this.items;
    },
  },
  async created() {
    this.fetchData();
  },
});
</script>
